import React from 'react';

const DashboardHome = () => {
    return (
        <div className="p-3">
            Home
        </div>
    );
};

export default DashboardHome;